module.exports = __webpack_public_path__ + "img/solution-lightXML-system-pic-2.7fe677bf.jpeg";